"use client";

import * as m from "motion/react-m";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

export function ProgressBar({ currentStep, totalSteps, className = "" }: ProgressBarProps) {
  return (
    <div className={`tw-flex tw-gap-2 tw-items-center ${className}`}>
      {Array.from({ length: totalSteps }).map((_, index) => {
        const isCurrent = index === currentStep - 1;
        const isCompleted = index < currentStep - 1;

        return (
          <div key={index} className='tw-h-1 tw-flex-1 tw-rounded-full tw-bg-gray-300 tw-overflow-hidden tw-relative'>
            <m.div
              className='tw-absolute tw-inset-0 tw-bg-black tw-rounded-full tw-origin-left'
              initial={{ scaleX: isCompleted ? 1 : 0 }}
              animate={{
                scaleX: isCurrent || isCompleted ? 1 : 0,
              }}
              transition={{
                duration: isCurrent ? 0.5 : 0,
                ease: [0.4, 0.0, 0.2, 1],
                delay: isCurrent ? 0.15 : 0,
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
